import * as React from 'react';
import Button from '@mui/material/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';
import { useContext, useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useParams , useLocation , useNavigate } from 'react-router-dom';


export default function ChangeLeadStatus() {
    const authCtx = useContext(AuthContext);

    // For status-substatus dropdowns
    const [statusOptions, setStatusOptions] = useState([]);
    const [uniqueParentStatuses, setUniqueParentStatuses] = useState([]);
    const [filteredSubStatuses, setFilteredSubStatuses] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedSubStatus, setSelectedSubStatus] = useState('');

      const location = useLocation();
      const navigate = useNavigate()
       // Support both old and new state structures
       const leadId = location.state?.leadId || location.state?.id;
       const title = location.state?.title || '';
       const returnUrl = location.state?.returnUrl;
       console.log('State received:', location.state)
       console.log(title , 'title@1234')
       console.log(leadId , 'leadId@1234')



    // Fetch status-substatus data
    useEffect(() => {
        const fetchStatusSubstatus = async () => {
            try {
                const response = await postRequest('private/get-status-sub-status', {}, authCtx.token);
                if (response?.status === 'success') {
                    const data = response.data || [];
                    setStatusOptions(data);

                    // Get unique parent statuses
                    const uniqueStatuses = [...new Set(data.map(item => item.parent_status))];
                    setUniqueParentStatuses(uniqueStatuses);
                }
            } catch (err) {
                console.error('Error fetching status-substatus:', err);
            }
        };

        fetchStatusSubstatus();
    }, [authCtx.token]);

    // Fetch current lead status and pre-fill
    useEffect(() => {
        const fetchCurrentStatus = async () => {
            if (leadId && statusOptions.length > 0) {
                try {
                    console.log('Fetching status for leadId:', leadId);
                    const response = await postRequest(`private/getLeadStatusSubStatus/${leadId}`, {}, authCtx.token);
                    console.log('Current status response:', response);
                    if (response?.status === 200 && response?.data) {
                        const { status, sub_status } = response.data;

                        if (status) {
                            setSelectedStatus(status);
                            const subStatuses = statusOptions.filter(item => item.parent_status === status);
                            setFilteredSubStatuses(subStatuses);
                        }
                        if (sub_status) {
                            setSelectedSubStatus(sub_status);
                        }
                    }
                } catch (err) {
                    console.error('Error fetching current lead status:', err);
                }
            }
        };
        fetchCurrentStatus();
    }, [leadId, statusOptions, authCtx.token]);

    // Handlers
    const handleStatusChange = (event) => {
        const selected = event.target.value;
        setSelectedStatus(selected);
        setSelectedSubStatus('');

        const subStatuses = statusOptions.filter(item => item.parent_status === selected);
        setFilteredSubStatuses(subStatuses);
    };

    const handleSubStatusChange = (event) => {
        setSelectedSubStatus(event.target.value);
    };

const handleSubmit = async () => {
    // Validation: At least status should be selected
    if (!selectedStatus) {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Please select a Status.',
        });
        return;
    }

    try {
        const response = await postRequest(
            `private/change-status-sub-status`,
            {
                lead_id:leadId,
                status: selectedStatus,
                sub_status: selectedSubStatus || ''
            },
            authCtx.token
        );

        if (response?.status == 200) {
            Swal.fire({
                icon: 'success',
                title: 'Status Updated!',
                text: `Lead updated to ${selectedStatus} / ${selectedSubStatus}`,
            });
            // Navigate back to return URL or construct the view URL
            if (returnUrl) {
                navigate(returnUrl);
            } else {
                navigate(`/leads/view/${title}/${leadId}`);
            }
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: response?.message || 'Could not update lead status.',
            });
        }
    } catch (error) {
        console.error('Update error:', error);
        Swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: 'Something went wrong while updating the status.',
        });
    }
};

    return (
        <>
            <div className='page-header pb-3'>
                <h1 className='mt-0 mb-0'>Change Lead Status</h1>
            </div>

            {/* Status Form */}
            <div className='page-top-formview mb-3'>
                <Form>
                    <Row className="mb-3">
                        <Col xs={7}>
                            <Form.Group controlId="statusSelect">
                                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                                    <InputLabel id="status-label">Status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        id="status"
                                        value={selectedStatus}
                                        label="Status"
                                        onChange={handleStatusChange}
                                    >
                                        {uniqueParentStatuses.map((status, index) => (
                                            <MenuItem key={index} value={status}>
                                                {status}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>

                        <Col xs={7}>
                            <Form.Group controlId="subStatusSelect">
                                <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
                                    <InputLabel id="sub-status-label">Sub-Status</InputLabel>
                                    <Select
                                        labelId="sub-status-label"
                                        id="sub-status"
                                        value={selectedSubStatus}
                                        label="Sub-Status"
                                        onChange={handleSubStatusChange}
                                        disabled={!selectedStatus}
                                    >
                                        {filteredSubStatuses.map((sub) => (
                                            <MenuItem key={sub._id} value={sub.status}>
                                                {sub.status}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>

                        <Col xs={7} className='gap-3 d-flex mt-2'>
                            <Button 
                                variant="outlined" 
                                className='red-outline-btn text-capitalize h-56'
                                onClick={() => navigate(returnUrl || `/leads/view/${title}/${leadId}`)}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                className='red-bg red-button text-capitalize h-56'
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    );
}
